import { jsx as _jsx } from "react/jsx-runtime";
import { SnackbarProvider } from 'notistack';
import Toast from './Toast';
const ToastsProvider = ({ anchorOrigin = {
    vertical: 'top',
    horizontal: 'center',
}, children, }) => {
    return (_jsx(SnackbarProvider, { anchorOrigin: anchorOrigin, Components: {
            default: Toast,
            info: Toast,
            error: Toast,
            success: Toast,
            warning: Toast,
        }, children: children }));
};
export default ToastsProvider;
